import { useCallback } from 'react';
import WorkspaceMember from 'src/entities/workspaceMember';
import { useQuery } from '@tanstack/react-query';
import { DEFAULT_QUERY_OPTIONS } from '@projects/queries/constants';
import User from 'src/entities/user';
import useWorkspaceSystem from '../systems/useWorkspaceSystem';
import { QueryKeys } from './keysAndFilters';
import { WorkspaceMemberJSON } from '../types';

const useFetchWorkspaceMembersQuery = ( { workspaceID }: { workspaceID: number } ) => {
	const workspaceSystem = useWorkspaceSystem();

	const select = useCallback(
		( workspaceMembers: WorkspaceMemberJSON[] ) => workspaceMembers.map( ( json ) => {
			const member = WorkspaceMember.fromJSON( {
				...json,
				workspace_id: workspaceID,
				user_id: json.user.id
			} );
			const user = User.fromJSON( json.user );
			return member.withUser( user ) as unknown as WorkspaceMember;
		} ),
		[]
	);

	return useQuery(
		QueryKeys.forWorkspaceMembers( { workspaceID } ),
		() => workspaceSystem.fetchWorkspaceMembers( { workspaceID } ),
		{
			select,
			...DEFAULT_QUERY_OPTIONS
		}
	);
}

export default useFetchWorkspaceMembersQuery;
